import { Injectable } from "@angular/core";
import { LandingPage, VariableData, VariableMetaData } from "@app/models";
import { ApiService, LandingService as LandingApiService } from "clearline-api";
import { AppConfigService } from "core-kit";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LandingService extends LandingApiService {
  constructor(protected api: ApiService, private configSvc: AppConfigService) {
    super(api);
  }

  getLandingPageById(id: number): Observable<LandingPage> {
    return this.api.get(`${this.serviceUrl}/${id}`, {});
  }

  getPublishedPageByPurpose(purposeId: number): Observable<LandingPage> {
    return this.api.get(`${this.serviceUrl}/purpose/${purposeId}`, {});
  }

  getPagePreview(pageId: number, brandId: number, locationId: number): Observable<LandingPage> {
    return this.api.get(`${this.serviceUrl}/preview/${pageId}/${brandId}/${locationId}`, {});
  }

  getTestPagePreview(pageId: number): Observable<LandingPage> {
    return this.api.get(`${this.serviceUrl}/previewTest/${pageId}`, {});
  }

  getLandingPageUrl(pageId: number, useTest = false, brandId: number = null, locationId: number = null): string {
    let pageUrl = this.configSvc.appData.shortLinkUrl + "/landing/";
    if (brandId && locationId && !useTest) {
      pageUrl += `${pageId}/${brandId}/${locationId}`;
    } else {
      pageUrl += "test/" + pageId;
    }
    return pageUrl;
  }

  getProdLandingPageUrl(pageId: number, brandName: string = null, locationId: number, widgetId: number): string {
    const pageUrl = `${this.configSvc.appData.shortLinkUrl}/${brandName}/${pageId}/${locationId}/${widgetId}`;
    return pageUrl;
  }

  getLandingPages(): Observable<LandingPage[]> {
    return this.api.get(`${this.serviceUrl}`, {});
  }

  getPublishedLandingPages(): Observable<LandingPage[]> {
    return this.api.get(`${this.serviceUrl}/published`, {});
  }

  createLandingPage(page: LandingPage): Observable<LandingPage> {
    return this.api.post(`${this.serviceUrl}`, page);
  }

  updateLandingPage(page: LandingPage): Observable<LandingPage> {
    return this.api.put(`${this.serviceUrl}/${page.id}`, page);
  }
  publish(pageId: number): Observable<LandingPage> {
    return this.api.post(`${this.serviceUrl}/publish/${pageId}`);
  }

  deleteLandingPage(page: LandingPage): Observable<LandingPage> {
    return this.api.delete(`${this.serviceUrl}/${page.id}`);
  }

  getVariableMetadata(): Observable<VariableMetaData[]> {
    return this.api.get(`${this.serviceUrl}/variableMetadata`, {});
  }

  getVariableValues(brandId: number, locationId: number): Observable<VariableData[]> {
    return this.api.get(`${this.serviceUrl}/variables/${brandId}/${locationId}`, {});
  }

  getCurrentUserVariableValues(): Observable<VariableData[]> {
    return this.api.get(`${this.serviceUrl}/variables`, {});
  }
}
